import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UploadedFileData } from '../domain/uploaded-file';
import { featureKey, FeatureState } from './file-upload.reducer';

const featureSelector = createFeatureSelector<FeatureState>(featureKey);

const selectCxbUploadedFiles = createSelector(featureSelector, (state: FeatureState) => state.uploadedFiles);

export const selectCxbUploadedFileByClientId = (clientId: string) =>
  createSelector(selectCxbUploadedFiles, (files: UploadedFileData[]) => {
    if (!files || files.length === 0) {
      return undefined;
    }
    return files.find((f) => f.clientId === clientId);
  });
